(function () {
  "use strict";

  var currentScript =
    document.currentScript ||
    (function () {
      var scripts = document.getElementsByTagName("script");
      return scripts[scripts.length - 1];
    })();

  var API_URL =
    (currentScript && currentScript.getAttribute("data-api-url")) ||
    "http://localhost:3000/api/chat";
  var BRAND_NAME =
    (currentScript && currentScript.getAttribute("data-brand-name")) ||
    "Les Papilles du CBD";

  var STORAGE_KEY = "lpc_chat_history";

  var conversationHistory = [];
  try {
    var saved = sessionStorage.getItem(STORAGE_KEY);
    if (saved) conversationHistory = JSON.parse(saved);
  } catch (e) {
    conversationHistory = [];
  }

  function persistHistory() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(conversationHistory));
    } catch (e) {
      /* stockage indisponible, on continue sans persistance */
    }
  }

  // ---------- Styles ----------
  var style = document.createElement("style");
  style.textContent =
    ":root{--lpc-green:#4b7357;--lpc-green-dark:#3a5a44;--lpc-cream:#f6f2ea;--lpc-text:#2f3630;--lpc-radius:16px;}" +
    "#lpc-chat-bubble{position:fixed;bottom:24px;right:24px;width:60px;height:60px;border-radius:50%;background:var(--lpc-green);box-shadow:0 4px 16px rgba(0,0,0,.18);cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:999999;border:none;transition:transform .15s ease;}" +
    "#lpc-chat-bubble:hover{transform:scale(1.06);}" +
    "#lpc-chat-bubble svg{width:28px;height:28px;fill:#fff;}" +
    "#lpc-chat-window{position:fixed;bottom:96px;right:24px;width:360px;max-width:calc(100vw - 32px);height:520px;max-height:calc(100vh - 140px);background:#fff;border-radius:var(--lpc-radius);box-shadow:0 8px 32px rgba(0,0,0,.22);display:none;flex-direction:column;overflow:hidden;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;z-index:999999;}" +
    "#lpc-chat-window.lpc-open{display:flex;}" +
    "#lpc-chat-header{background:var(--lpc-green);color:#fff;padding:16px 18px;display:flex;align-items:center;justify-content:space-between;}" +
    "#lpc-chat-header h3{margin:0;font-size:15px;font-weight:600;}" +
    "#lpc-chat-header p{margin:2px 0 0;font-size:12px;opacity:.85;}" +
    "#lpc-chat-close{background:none;border:none;color:#fff;font-size:20px;cursor:pointer;line-height:1;padding:4px;}" +
    "#lpc-chat-messages{flex:1;overflow-y:auto;padding:16px;background:var(--lpc-cream);display:flex;flex-direction:column;gap:10px;}" +
    ".lpc-msg{max-width:82%;padding:10px 13px;border-radius:14px;font-size:14px;line-height:1.45;white-space:pre-wrap;word-wrap:break-word;}" +
    ".lpc-msg.lpc-user{align-self:flex-end;background:var(--lpc-green);color:#fff;border-bottom-right-radius:4px;}" +
    ".lpc-msg.lpc-assistant{align-self:flex-start;background:#fff;color:var(--lpc-text);border:1px solid #e6e0d4;border-bottom-left-radius:4px;}" +
    ".lpc-typing{align-self:flex-start;display:flex;gap:4px;padding:10px 13px;}" +
    ".lpc-typing span{width:6px;height:6px;border-radius:50%;background:#9aa89e;animation:lpc-bounce 1.2s infinite ease-in-out;}" +
    ".lpc-typing span:nth-child(2){animation-delay:.15s;}" +
    ".lpc-typing span:nth-child(3){animation-delay:.3s;}" +
    "@keyframes lpc-bounce{0%,80%,100%{transform:translateY(0);opacity:.5;}40%{transform:translateY(-4px);opacity:1;}}" +
    "#lpc-chat-form{display:flex;gap:8px;padding:12px;border-top:1px solid #ece6d8;background:#fff;}" +
    "#lpc-chat-input{flex:1;border:1px solid #d9d2c1;border-radius:20px;padding:10px 14px;font-size:14px;outline:none;font-family:inherit;color:var(--lpc-text);}" +
    "#lpc-chat-input:focus{border-color:var(--lpc-green);}" +
    "#lpc-chat-send{background:var(--lpc-green);border:none;color:#fff;width:38px;height:38px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;}" +
    "#lpc-chat-send:hover{background:var(--lpc-green-dark);}" +
    "#lpc-chat-send:disabled{opacity:.5;cursor:not-allowed;}" +
    "#lpc-chat-error{font-size:12px;color:#a33;padding:0 16px 10px;display:none;}" +
    "@media(max-width:480px){#lpc-chat-window{right:16px;left:16px;width:auto;bottom:88px;}}";
  document.head.appendChild(style);

  // ---------- Structure DOM ----------
  var bubble = document.createElement("button");
  bubble.id = "lpc-chat-bubble";
  bubble.setAttribute("aria-label", "Ouvrir le chat");
  bubble.innerHTML =
    '<svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.03 2 11c0 2.42 1.13 4.6 2.94 6.17L4 22l4.9-1.62A11.6 11.6 0 0 0 12 20c5.52 0 10-4.03 10-9s-4.48-9-10-9z"/></svg>';

  var win = document.createElement("div");
  win.id = "lpc-chat-window";
  win.innerHTML =
    '<div id="lpc-chat-header">' +
    "<div><h3>" +
    escapeHtml(BRAND_NAME) +
    '</h3><p>Notre assistant bien-être</p></div>' +
    '<button id="lpc-chat-close" aria-label="Fermer">&times;</button>' +
    "</div>" +
    '<div id="lpc-chat-messages"></div>' +
    '<div id="lpc-chat-error"></div>' +
    '<form id="lpc-chat-form">' +
    '<input id="lpc-chat-input" type="text" autocomplete="off" placeholder="Écrivez votre message..." />' +
    '<button id="lpc-chat-send" type="submit" aria-label="Envoyer">' +
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="#fff"><path d="M2 21l21-9L2 3v7l15 2-15 2z"/></svg>' +
    "</button>" +
    "</form>";

  document.body.appendChild(bubble);
  document.body.appendChild(win);

  var messagesEl = win.querySelector("#lpc-chat-messages");
  var errorEl = win.querySelector("#lpc-chat-error");
  var formEl = win.querySelector("#lpc-chat-form");
  var inputEl = win.querySelector("#lpc-chat-input");
  var sendBtn = win.querySelector("#lpc-chat-send");
  var closeBtn = win.querySelector("#lpc-chat-close");

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  function renderHistory() {
    messagesEl.innerHTML = "";
    conversationHistory.forEach(function (entry) {
      appendMessage(entry.role, entry.content, false);
    });
    scrollToBottom();
  }

  function appendMessage(role, content, animate) {
    var div = document.createElement("div");
    div.className = "lpc-msg " + (role === "user" ? "lpc-user" : "lpc-assistant");
    div.textContent = content;
    messagesEl.appendChild(div);
    if (animate !== false) scrollToBottom();
    return div;
  }

  function scrollToBottom() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function showTyping() {
    var el = document.createElement("div");
    el.className = "lpc-typing";
    el.id = "lpc-typing-indicator";
    el.innerHTML = "<span></span><span></span><span></span>";
    messagesEl.appendChild(el);
    scrollToBottom();
    return el;
  }

  function showError(message) {
    errorEl.textContent = message;
    errorEl.style.display = "block";
  }

  function clearError() {
    errorEl.style.display = "none";
    errorEl.textContent = "";
  }

  bubble.addEventListener("click", function () {
    win.classList.add("lpc-open");
    bubble.style.display = "none";
    if (conversationHistory.length === 0) {
      appendMessage(
        "assistant",
        "Bonjour et bienvenue chez " +
          BRAND_NAME +
          " ! Comment puis-je vous aider aujourd'hui ?",
        false
      );
    }
    inputEl.focus();
  });

  closeBtn.addEventListener("click", function () {
    win.classList.remove("lpc-open");
    bubble.style.display = "flex";
  });

  formEl.addEventListener("submit", function (e) {
    e.preventDefault();
    sendMessage();
  });

  function sendMessage() {
    var text = inputEl.value.trim();
    if (!text) return;

    clearError();
    appendMessage("user", text);
    conversationHistory.push({ role: "user", content: text });
    persistHistory();

    inputEl.value = "";
    inputEl.disabled = true;
    sendBtn.disabled = true;

    var typingEl = showTyping();
    var assistantEl = null;
    var assistantText = "";

    fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: text,
        conversation_history: conversationHistory.slice(0, -1),
      }),
    })
      .then(function (response) {
        if (!response.ok || !response.body) {
          return response
            .json()
            .catch(function () {
              return { error: "Erreur serveur." };
            })
            .then(function (data) {
              throw new Error(data.error || "Erreur serveur.");
            });
        }

        var reader = response.body.getReader();
        var decoder = new TextDecoder();
        var buffer = "";

        function pump() {
          return reader.read().then(function (result) {
            if (result.done) return;
            buffer += decoder.decode(result.value, { stream: true });

            var events = buffer.split("\n\n");
            buffer = events.pop();

            events.forEach(function (rawEvent) {
              handleSseEvent(rawEvent);
            });

            return pump();
          });
        }

        function handleSseEvent(rawEvent) {
          var lines = rawEvent.split("\n");
          var eventType = "message";
          var dataLines = [];

          lines.forEach(function (line) {
            if (line.indexOf("event:") === 0) {
              eventType = line.slice(6).trim();
            } else if (line.indexOf("data:") === 0) {
              dataLines.push(line.slice(5).trim());
            }
          });

          if (dataLines.length === 0) return;
          var dataStr = dataLines.join("\n");

          if (eventType === "error") {
            var parsedErr;
            try {
              parsedErr = JSON.parse(dataStr);
            } catch (e) {
              parsedErr = { error: "Une erreur est survenue." };
            }
            throw new Error(parsedErr.error || "Une erreur est survenue.");
          }

          var payload;
          try {
            payload = JSON.parse(dataStr);
          } catch (e) {
            return;
          }

          if (
            payload.type === "content_block_delta" &&
            payload.delta &&
            payload.delta.type === "text_delta"
          ) {
            if (typingEl) {
              typingEl.remove();
              typingEl = null;
            }
            if (!assistantEl) {
              assistantEl = appendMessage("assistant", "");
            }
            assistantText += payload.delta.text;
            assistantEl.textContent = assistantText;
            scrollToBottom();
          }
        }

        return pump();
      })
      .then(function () {
        if (typingEl) typingEl.remove();
        if (assistantText) {
          conversationHistory.push({ role: "assistant", content: assistantText });
          persistHistory();
        } else if (!assistantEl) {
          showError("Le service n'a pas pu répondre. Merci de réessayer.");
        }
      })
      .catch(function (err) {
        if (typingEl) typingEl.remove();
        if (assistantEl) assistantEl.remove();
        showError(err.message || "Une erreur est survenue, merci de réessayer.");
      })
      .finally(function () {
        inputEl.disabled = false;
        sendBtn.disabled = false;
        inputEl.focus();
      });
  }

  renderHistory();
})();
